import React from 'react';

function FormattingAa(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M5.258 14.684L4.25 17.87H2L6.302 5H9.434L13.682 17.87H11.198L10.172 14.684H5.258ZM5.816 12.938H9.614L7.724 6.962L5.816 12.938ZM17.93 18.05C19.37 18.05 20.198 17.528 20.81 16.718V17.87H22.952V11.696C22.952 9.122 21.296 8.258 19.19 8.258C17.084 8.258 15.338 9.176 15.158 11.372H17.264C17.372 10.436 17.93 9.896 19.064 9.896C20.342 9.896 20.774 10.526 20.774 11.786V12.272H19.604C16.904 12.272 14.78 13.064 14.78 15.26C14.78 17.222 16.202 18.05 17.93 18.05ZM16.94 15.17C16.94 15.962 17.372 16.484 18.452 16.484C19.784 16.484 20.774 15.782 20.774 14.576V13.64H19.658C18.002 13.64 16.94 14.018 16.94 15.17Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default FormattingAa;
